import script from "./RequestCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestCard.vue?vue&type=script&setup=true&lang=js"

import "./RequestCard.vue?vue&type=style&index=0&id=bf1b869a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf1b869a"]])

export default __exports__